import { render, staticRenderFns } from "./election-component.vue?vue&type=template&id=5e01f8ea&scoped=true"
import script from "./election-component.ts?vue&type=script&lang=ts&external"
export * from "./election-component.ts?vue&type=script&lang=ts&external"
import style0 from "./election-component.scss?vue&type=style&index=0&id=5e01f8ea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01f8ea",
  null
  
)

export default component.exports